module.exports = __webpack_public_path__ + "img/disetujui_dibayarkan_penuh.54c39eae.svg";